import {
    CoreApplicationContext,
    CoreRequest,
    CoreUser,
    GASettingKeys,
} from '@eventbrite/context-gen';
import { History, Location } from 'history';
import React from 'react';
import { match } from 'react-router-dom';
import {
    EnvProvider,
    LocationProvider,
    RouteProvider,
    SearchProvider,
} from '../../context';

interface HomePageProvidersProps {
    app_version?: string;
    app_name: string;
    env: CoreApplicationContext['env'];
    gaSettings: GASettingKeys;
    user?: CoreUser;
    request?: CoreRequest;
    match?: match;
    location?: Location;
    history?: History;
}

class HomePageProviders extends React.Component<HomePageProvidersProps> {
    render() {
        const {
            user,
            env,
            gaSettings,
            request,
            app_version,
            app_name,
            match,
            history,
            location,
        } = this.props;

        return (
            <EnvProvider
                env={env}
                gaSettings={gaSettings}
                request={request}
                user={user}
                app_version={app_version}
                app_name={app_name}
            >
                <RouteProvider
                    match={match}
                    location={location}
                    history={history}
                >
                    <LocationProvider locationSlug="">
                        <SearchProvider
                            initialQuery={{
                                tags: [''],
                            }}
                        >
                            {this.props.children}
                        </SearchProvider>
                    </LocationProvider>
                </RouteProvider>
            </EnvProvider>
        );
    }
}

export default HomePageProviders;
